package org.lennycodes.hldi.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Text
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.styles.contactInfoCardStyle

@Composable
fun ContactInfoCard(icon: String, title: String, content: @Composable () -> Unit) {
    Div(attrs = Modifier
        .padding(24.px)
        .then(contactInfoCardStyle.toModifier())
        .toAttrs())
        {
        Div(attrs = { style { fontSize(24.px); marginBottom(8.px) } }) {
            Text(icon)
        }
        H3(
            attrs = {
                style {
                    fontSize(18.px)
                    color(HLDITheme.Colors.text)
                    marginBottom(4.px)
                }
            }
        ) { Text(title) }
        content()
    }
}